import React, { useState, useEffect } from "react";
import { Button } from "../../../components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger, SheetFooter } from "../../../components/ui/sheet"
import {
    Building2,
} from "lucide-react"
import DocumentViewer from "./FileViewer";

const FileViewerModal = (props) => {
    const handleClose = () => {
        props.setIsShow(false);
    }
    return (
        <div>
            <Sheet open={props?.isShow} onOpenChange={props.setIsShow}>
                <SheetContent side="right" className="w-full min-w-[1000px] p-0 overflow-auto">
                    <SheetHeader className="bg-gradient-to-r from-purple-50 to-blue-50 p-6 border-b detail-header">
                        <div className="flex items-center justify-between">
                            <div className="flex items-center space-x-3">
                                <div className="bg-purple-100 p-2 rounded-lg">
                                    <Building2 className="h-6 w-6 text-purple-600" />
                                </div>
                                <div>
                                    <SheetTitle className="text-xl font-bold text-gray-900">Documents</SheetTitle>
                                    <p className="text-sm text-gray-600 mt-1">You can see the certificates of this order</p>
                                </div>
                            </div>
                        </div>
                    </SheetHeader>
                    <div className="">
                        <DocumentViewer files={props?.documents?.certificationUrls ? props?.documents?.certificationUrls : []}/>
                        <SheetFooter>
                            <div className="flex gap-3 pt-4 ml-4">
                                <Button type="button" variant="outline" onClick={handleClose}>
                                    Back
                                </Button>
                            </div>
                        </SheetFooter>
                    </div>
                </SheetContent>
            </Sheet>
        </div>
    );
};

export default FileViewerModal;
